export enum DataConflictOptionsEnum {
  OVERWRITE = 0,
  REFRESH = 1,
  OPEN = 2
}
